import React, { memo } from 'react'
import { Card } from 'transfix-ui/components/Card'
import FormattedPhoneNumber from 'transfix-ui/components/FormattedPhoneNumber'

interface IPhoneInfoCardProps {
  cellPhone?: string
  phoneModel?: string
  phoneOS?: string
  transfixAppVersion?: string
}

export const PhoneInfoCard = memo(
  ({ cellPhone, phoneModel, phoneOS, transfixAppVersion }: IPhoneInfoCardProps) => {
    return (
      <Card title='Phone Info'>
        <p>
          <span className='mr1 text-secondary'>Cell:</span>
          {cellPhone ? <FormattedPhoneNumber phoneNumber={cellPhone} /> : ' -- '}
        </p>
        <p>
          <span className='mr1 text-secondary'>Phone Model:</span>
          {phoneModel || ' -- '}
        </p>
        <p>
          <span className='mr1 text-secondary'>Phone OS:</span>
          {phoneOS || ' -- '}
        </p>
        <p>
          <span className='mr1 text-secondary'>Transfix App Version:</span>
          {transfixAppVersion || ' -- '}
        </p>
      </Card>
    )
  }
)
